import { api, getToken, AUTH_EXPIRED_EVENT } from "./api";
import { isProductionConsole } from "./appMode.js";
import { getItem, removeItem } from "./safeStorage";
import { clearSession } from "../components/AuthGate";

/**
 * Validates JWT on load/hashchange and redirects on expiry (production host only).
 * Returns cleanup for useEffect.
 */
export function installProductionAuth({
  setAuthed,
  toast,
  goRoute,
  setRoute,
  setUserMenuOpen,
  setChatInitialQuery,
  setPage,
  getAppPage,
  getRoute,
}) {
  if (!isProductionConsole) return () => {};

  let cancelled = false;

  const redirectAuthedFromAuthRoute = () => {
    const pending = getItem("wecrew_pending_chat", "session");
    if (pending) {
      removeItem("wecrew_pending_chat", "session");
      setChatInitialQuery(pending);
      goRoute("chat");
      setPage("chat");
    } else {
      goRoute("app");
      setPage(getAppPage());
    }
    setRoute("app");
  };

  const syncProdAuth = async () => {
    const token = getToken();
    if (!token) {
      removeItem("wecrew_session");
      if (!cancelled) setAuthed(false);
      return;
    }
    try {
      await api.me();
      if (cancelled) return;
      setAuthed(true);
      const r = getRoute();
      if (r === "signin" || r === "signup") redirectAuthedFromAuthRoute();
    } catch {
      if (cancelled) return;
      clearSession();
      setAuthed(false);
      const r = getRoute();
      if (r === "app" || r === "chat" || r === "integrations") {
        goRoute("signin");
        setRoute("signin");
      }
    }
  };

  const onSessionExpired = () => {
    clearSession();
    setAuthed(false);
    setUserMenuOpen(false);
    goRoute("signin");
    setRoute("signin");
    toast("Session expired — sign in with email to upload.", "info");
  };

  window.addEventListener(AUTH_EXPIRED_EVENT, onSessionExpired);
  window.addEventListener("hashchange", syncProdAuth);
  syncProdAuth();

  return () => {
    cancelled = true;
    window.removeEventListener(AUTH_EXPIRED_EVENT, onSessionExpired);
    window.removeEventListener("hashchange", syncProdAuth);
  };
}
